import React, { Component } from 'react';
import windowSize from 'react-window-size';
import _ from 'lodash';

import './GameScreen.css';
import { Track } from '../Track/Track'
import { Controller } from '../Controller/Controller'
import { requestInterval } from '../../requestInterval';
import { TRACK_LENGTH, MAX_FUEL, MAX_SPEED, FAIL_DOWN } from '../../consts';

class GameScreenCore extends Component {
  state = {
    car1: 0,
    car1Speed: 1,
    car1TargetSpeed: 1,
    car1Gasoline: 0,
    car1MaxGasoline: MAX_FUEL,
    car2: 0,
    car2Speed: 1,
    car2TargetSpeed: 1,
    car2Gasoline: 0,
    car2MaxGasoline: MAX_FUEL,
    lastTime: Date.now()
  }
  componentDidMount() {
    this.requestLoop();
  }
  requestLoop = () => {
    const { car1, car2 } = this.state;
    if (car1 >= TRACK_LENGTH && car2 < car1) {
      setTimeout(() => alert('You Win. Reload the page to race again!'), 2000);
    } else if (car2 >= TRACK_LENGTH && car1 < car2) {
      setTimeout(() => alert('You Lose. Reload the page to try again!'), 2000);
    } else {
      requestAnimationFrame(this.loop);
    }
  }
  loop = () => {
    this.setState(state => {
      const thisTime = Date.now();
      const delta = (thisTime - state.lastTime) / 1000;
      const car1Gasoline = this.preSetFuel(state, -0.2 * delta);
      const car1TargetSpeed = state.car1TargetSpeed + (state.car1Speed-state.car1TargetSpeed) * delta/2;
      const car2TargetSpeed = state.car2TargetSpeed + (state.car2Speed-state.car2TargetSpeed) * delta/2;
      let car1 = state.car1;
      if (state.car1Gasoline) {
        car1 = Math.min(car1 + state.car1TargetSpeed * delta, TRACK_LENGTH);
      }
      const car2Gasoline = this.preSet2Fuel(state, -0.2 * delta);
      let car2 = state.car2;
      if (state.car2Gasoline) {
        car2 = Math.min(car2 + state.car2TargetSpeed * delta, TRACK_LENGTH);
      }
      return {
        car1, car1Gasoline, car1TargetSpeed,
        car2, car2Gasoline, car2TargetSpeed,
        lastTime: thisTime
      }
    }, this.requestLoop)
  }
  setSpeed = (value) => {
    let delta;
    this.setState(state => {
      delta = Math.min(state.car1Speed + value, MAX_SPEED) - state.car1Speed;
      return { car1Speed: Math.min(state.car1Speed + value, MAX_SPEED) }
    });
    setTimeout(() => this.setState(state => ({
      car1Speed: Math.max(state.car1Speed - delta, 1)
    })), 5000);
  }
  preSetFuel = (state, value) => {
    return Math.max(Math.min(state.car1Gasoline + value, state.car1MaxGasoline), 0)
  }
  setFuel = (value) => {
    this.setState(state => ({
      car1Gasoline: this.preSetFuel(state, value)
    }));
  }
  setMaxGasoline = (value) => {
    this.setState(state => ({
      car1MaxGasoline: Math.max(Math.min(state.car1MaxGasoline + value * FAIL_DOWN, MAX_FUEL), 0),
    }));
  }
  set2Speed = (value) => {
    let delta;
    this.setState(state => {
      delta = Math.min(state.car2Speed + value, MAX_SPEED) - state.car2Speed;
      return { car2Speed: Math.min(state.car2Speed + value, MAX_SPEED) }
    });
    setTimeout(() => this.setState(state => ({
      car2Speed: Math.max(state.car2Speed - delta, 1)
    })), 5000);
  }
  preSet2Fuel = (state, value) => {
    return Math.max(Math.min(state.car2Gasoline + value, state.car2MaxGasoline), 0)
  }
  set2Fuel = (value) => {
    this.setState(state => ({
      car2Gasoline: this.preSetFuel(state, value)
    }));
  }
  set2MaxGasoline = (value) => {
    this.setState(state => ({
      car2MaxGasoline: Math.max(Math.min(state.car2MaxGasoline + value * FAIL_DOWN, MAX_FUEL), 0),
    }));
  }
  onRolled = (values) => {
    const numberOfGear = _.filter(values, value => value == 'gear').length;
    const numberOfDead = _.filter(values, value => value == 'dead').length;
    const numberOfEnergy = _.filter(values, value => value == 'energy').length;
    const numberOfFuel = _.filter(values, value => value == 'fuel').length;
    const numberOfFail = _.filter(values, value => value == 'fail').length;

    if (numberOfFuel == 3) return this.setFuel(MAX_FUEL);
    if (numberOfEnergy == 3) return this.setSpeed(MAX_SPEED);
    
    this.setFuel(numberOfFuel * 0.5);
    this.setSpeed(numberOfEnergy);
    this.setMaxGasoline(numberOfGear);
    this.setMaxGasoline(-numberOfFail);
  }
  onEnemyRolled = (values) => {
    const numberOfGear = _.filter(values, value => value == 'gear').length;
    const numberOfDead = _.filter(values, value => value == 'dead').length;
    const numberOfEnergy = _.filter(values, value => value == 'energy').length;
    const numberOfFuel = _.filter(values, value => value == 'fuel').length;
    const numberOfFail = _.filter(values, value => value == 'fail').length;

    if (numberOfFuel == 3) return this.set2Fuel(MAX_FUEL);
    if (numberOfEnergy == 3) return this.set2Speed(MAX_SPEED);
    
    this.set2Fuel(numberOfFuel * 0.5);
    this.set2Speed(numberOfEnergy);
    this.set2MaxGasoline(numberOfGear);
    this.set2MaxGasoline(-numberOfFail);
  }
  render() {
    const {
      windowWidth,
      windowHeight
    } = this.props;

    const {
      car1, car2
    } = this.state;

    return (
      <div className="container">
        <Track {...this.state} />
        <Controller {...this.state} onRolled={this.onRolled} onEnemyRolled={this.onEnemyRolled}/>
      </div>
    );
  }
}

export const GameScreen = windowSize(GameScreenCore);


// WEBPACK FOOTER //
// ./src/components/GameScreen/GameScreen.js